module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nextfuturelab.7c7dde9f4b70ee549b79937d67a7f22f.png";